<template>
    <DFormRow
        :label="__('customers.contracts.responsible_sales_agent')"
        :error="errors.responsible_sales_agent"
    >
        <DInput
            id="responsible_sales_agent"
            :model-value="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'ResponsibleSalesAgent',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['update:modelValue']
}
</script>
